import { Component, Input, OnInit } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { ScrollerSectionType01Component } from "../../scroller-section/scroller_section-type01/scroller_section-type01.component";
import { NgFor } from '@angular/common';
import { DealsType01Component } from "../../deals/deals-type01/deals-type01.component";
import { MapType01Component } from "../../map/map-type01/map-type01.component";
import { CarouselAllModule } from '@syncfusion/ej2-angular-navigations';
import { CountersType01Component } from '../../counter/counters-type01/counters-type01.component';
import { members } from '../../members/member-info';

@Component({
  selector: 'app-why_us-type02',
  standalone: true,
  imports: [RouterLink, MatIconModule, MatTooltipModule, GoogleMapsModule, ScrollerSectionType01Component, NgFor, DealsType01Component, MapType01Component,CarouselAllModule,NgFor, CountersType01Component],
  templateUrl: './why_us-type02.component.html',
  styleUrl: './why_us-type02.component.scss'
})
export class WhyUsType02Component implements OnInit {
    @Input('heading') heading: string = '';
    @Input('title') title: string = '';
    @Input('tagline') tagline: string = '';
    @Input('tagline2') tagline2: string = '';
    @Input('logo') logo: string = '';
    @Input('text') text: string = '';
    @Input('url') url: any = {};
    @Input('options') options: any = {
        showIcons: false,
        showLogo: false,
        showMap: true,
        showCarousel: false
    };
    
    public view: any = {
      defaultLat : -27.991448970021764, 
      defaultLng: 26.75858065791476,
      locations : [
        { lat: -26.2426705296327, lng: 28.246879880202858 },  //XL Boksburg Travel
        { lat: -26.15251801582328, lng: 28.337870574144677 }, //XL Elite Travel
        { lat: -25.859489982353367, lng: 28.176536263303085 },  //XL Centurion Travel
        { lat: -26.1587366129588, lng:  28.058879592546695 },  //XL Fly Now Travel - Houghton  
        { lat: -25.78501730788294, lng: 28.281182142499855 },  //XL Glenwood Travel (Menlyn Maine) , 

        { lat: -29.832139010876556, lng: 31.016155872131577 },  //XL Nexus Travel - Durban
        { lat: -33.871994384188824, lng: 18.520065470074645 },  //XL Sandown Travel - Cape Town , 
        { lat: -22.53412339666899, lng: 17.10089160341932  },  //XL The Travel Professionals - Namibia , 
        { lat: -25.78501730788294, lng: 28.281182142499855 },  //XL Wild Travel
        { lat: -29.108035165386234, lng:  26.213584474633613},  //XL Astra Travel - Bloemfontein (Head Office) ,
      ],
      map: {
        maxZoom: 20,
        style : [
            {
                "stylers": [
                    {
                        "hue": "#ffb718"
                    },
                    {
                        "saturation": 50
                    }
                ]
            },
            {
                "featureType": "water",
                "stylers": [
                    {
                        //"color": "#f0f4f9"
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ]
        },
      carouselItems : [
            {
            src: 'https://media.istockphoto.com/id/904172104/photo/weve-made-it-all-this-way-i-am-proud.jpg?s=612x612&w=0&k=20&c=MewnsAhbeGRcMBN9_ZKhThmqPK6c8nCT8XYk5ZM_hdg=',
            alt: ' travel 1',
            caption: 'Caption for image 1'
            },
            {
            src: 'https://www.shutterstock.com/image-photo/woman-mountaineering-backpack-solo-girl-260nw-2442519635.jpg',
            alt: ' travel 2',
            caption: 'Caption for image 2'
            },
            {
            src: 'https://i0.wp.com/www.aussieontheroad.com/wp-content/uploads/2014/08/philipp-kammerer-6Mxb_mZ_Q8E-unsplash.jpg',
            alt: ' travel 3',
            caption: 'Caption for image 3'
            },
            {
            src: 'https://media.istockphoto.com/id/1285301614/photo/young-man-arms-outstretched-by-the-sea-at-sunrise-enjoying-freedom-and-life-people-travel.jpg?s=612x612&w=0&k=20&c=0QW6GnkuFNYcPZhy26XVHuTc2avJTK8u6l_1iT0SlZk=',
            alt: ' travel 4',
            caption: 'Caption for image 4'
            }
        ]
    }

    ngOnInit(): void {
        this.view.heading = this.heading;
        this.view.title = this.title;
        this.view.tagline = this.tagline;
        this.view.tagline2 = this.tagline2;
        this.view.logo = this.logo;
        this.view.text = this.text;
        this.view.url = this.url;
        this.view.options = this.options;
        this.loadMembers();
    }
    loadMembers() {
    this.view.brances = members;
    this.view.filteredCardDataList = this.view.brances;
    this.view.originalCardDataList = this.view.brances;

    this.view.locations = members;
  }
    showTab(tab: string): void {
        this.view.selectedTab = tab;
    }
    currentIndex = 0;
    private intervalId: any;
    getTransform() {
        return `translateX(-${this.currentIndex * 100}%)`;
    }
    startAutoRotate() {
        this.intervalId = setInterval(() => {
        this.next();
        }, 3000); // Change image every 3 seconds
    }
    stopAutoRotate() {
        if (this.intervalId) {
        clearInterval(this.intervalId);
        }
    }
    next() {
        this.currentIndex = (this.currentIndex < this.view.carouselItems.length - 1) ? this.currentIndex + 1 : 0;
    }

}
